import { useEffect, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import { fetchSimplePageByInternalTitle } from '../helpers/contentfulHelper';
import styles from '../styles/AccoyaPage.module.css';

const AccoyaPage = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const load = async () => {
      const data = await fetchSimplePageByInternalTitle('Accoya Page');
      setPage(data);
    };
    load();
  }, []);

  const fields = page?.fields || {};
  const copy = fields.copy || null;
  const logoAsset =
    fields.logo ||
    fields.pageLogo ||
    fields.brandLogo ||
    fields.image ||
    null;
  const logoUrl = logoAsset?.fields?.file?.url ? `https:${logoAsset.fields.file.url}` : '';
  const logoAlt = logoAsset?.fields?.title || 'Accoya logo';

  const richTextOptions = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const href = node?.data?.uri || '';
        const opensNewTab =
          href.startsWith('/docs/') || href.toLowerCase().endsWith('.pdf');

        return (
          <a
            href={href}
            target={opensNewTab ? '_blank' : undefined}
            rel={opensNewTab ? 'noreferrer' : undefined}
          >
            {children}
          </a>
        );
      },
    },
  };

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <p className={styles.kicker}>Affiliates</p>
          {logoUrl ? (
            <div className={styles.logoWrap}>
              <img src={logoUrl} alt={logoAlt} className={styles.logo} />
            </div>
          ) : null}
        </header>

        <section className={styles.section}>
          {copy ? (
            <div className={styles.richText}>{documentToReactComponents(copy, richTextOptions)}</div>
          ) : (
            <div className={styles.richText}>
              <p>Accoya page content is coming soon.</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
};

export default AccoyaPage;
